// =====================
// HELPERS
// =====================
function bmwMoney(cents) {
  return '£' + (cents / 100).toFixed(2);
}

function bmwUpdateCount(count) {
  const btn = document.querySelector('.bmw-header-right .bmw-cart-button');
  if (btn) btn.textContent = 'view cart (' + count + ')';
}

// =====================
// CART DRAWER
// =====================
function bmwOpenCart() {
  const drawer = document.getElementById('bmwCartDrawer');
  const overlay = document.getElementById('bmwCartOverlay');
  if (drawer) drawer.classList.add('bmw-cart-open');
  if (overlay) overlay.classList.add('bmw-cart-open');
  document.body.style.overflow = 'hidden';
  bmwRenderCart();
}

function bmwCloseCart() {
  const drawer = document.getElementById('bmwCartDrawer');
  const overlay = document.getElementById('bmwCartOverlay');
  if (drawer) drawer.classList.remove('bmw-cart-open');
  if (overlay) overlay.classList.remove('bmw-cart-open');
  document.body.style.overflow = '';
}

async function bmwRenderCart() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  const itemsEl = document.getElementById('bmwCartItems');
  const subtotalEl = document.getElementById('bmwCartSubtotal');
  const footEl = document.getElementById('bmwCartFoot');
  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<p class="bmw-mono-13 bmw-cart-empty">your cart is empty.</p>';
    if (footEl) footEl.style.display = 'none';
  } else {
    if (footEl) footEl.style.display = 'flex';
    itemsEl.innerHTML = cart.items.map(function(item) {
      return '<div class="bmw-cart-item">' +
        '<img src="' + item.image + '" alt="" class="bmw-cart-item-img">' +
        '<div class="bmw-cart-item-info">' +
          '<a href="' + item.url + '" class="bmw-mono-13 bmw-cart-item-title">' + item.product_title.toLowerCase() + '</a>' +
          '<span class="bmw-mono-13">' + bmwMoney(item.final_price) + '</span>' +
          '<button class="bmw-cart-remove" onclick="bmwRemoveItem(\'' + item.key + '\')">remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
    if (subtotalEl) subtotalEl.textContent = bmwMoney(cart.total_price);
  }
  bmwUpdateCount(cart.item_count);
}

async function bmwRemoveItem(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  bmwRenderCart();
  bmwRefreshProductState();
}

// =====================
// PRODUCT INLINE STATE
// =====================
async function bmwRefreshProductState() {
  const variantInput = document.getElementById('bmwProductVariantId');
  if (!variantInput) return;
  const variantId = parseInt(variantInput.value);

  const res = await fetch('/cart.js');
  const cart = await res.json();
  const inCartItem = cart.items.find(function(i) { return i.variant_id === variantId; });

  const addBtn = document.getElementById('bmwAddBtn');
  const inCart = document.getElementById('bmwInCart');
  const mini = document.getElementById('bmwMiniCart');

  if (inCartItem) {
    if (addBtn) addBtn.style.display = 'none';
    if (inCart) inCart.style.display = 'inline-block';
    if (mini) mini.style.display = 'flex';
  } else {
    if (addBtn) addBtn.style.display = 'inline-block';
    if (inCart) inCart.style.display = 'none';
    if (mini) mini.style.display = 'none';
  }

  if (cart.item_count > 0 && mini) {
    document.getElementById('bmwMiniCount').textContent = cart.item_count + ' item' + (cart.item_count > 1 ? 's' : '') + ' in cart';
    document.getElementById('bmwMiniSubtotal').textContent = bmwMoney(cart.total_price);
  }
}

async function bmwRemoveCurrentProduct() {
  const variantId = parseInt(document.getElementById('bmwProductVariantId').value);
  const res = await fetch('/cart.js');
  const cart = await res.json();
  const item = cart.items.find(function(i) { return i.variant_id === variantId; });
  if (!item) return;
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: item.key, quantity: 0 })
  });
  await bmwRefreshProductState();
  const c = await (await fetch('/cart.js')).json();
  bmwUpdateCount(c.item_count);
}

// =====================
// INIT
// =====================
document.addEventListener('DOMContentLoaded', function() {

  

  // add to cart button
  const addBtn = document.getElementById('bmwAddBtn');
  if (addBtn) {
    addBtn.addEventListener('click', async function(e) {
      e.preventDefault();
      const variantId = document.getElementById('bmwProductVariantId').value;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      await bmwRefreshProductState();
      const c = await (await fetch('/cart.js')).json();
      bmwUpdateCount(c.item_count);
    });
  }

  // in-cart button removes on click (attached ONCE here)
  const inCartBtn = document.getElementById('bmwInCart');
  if (inCartBtn) {
    inCartBtn.addEventListener('click', async function() {
      await bmwRemoveCurrentProduct();
    });
  }

  // initial count + product state
  fetch('/cart.js').then(r => r.json()).then(c => bmwUpdateCount(c.item_count));
  bmwRefreshProductState();

  // escape closes cart
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') bmwCloseCart();
  });

  // newsletter form: handled server-side in sections/news-page.liquid
});

/* the client-side Mailjet call that lived here was removed 27.08.26.
   it shipped a live api key and secret to every visitor. signups go
   through the netlify function instead — see sections/news-page.liquid.
   never put a credential in a file the browser can read. */


